var map = {
	"./DeleteIcon.svg": 318,
	"./MoreIcon.svg": 138,
	"./MoreIcon_hover.svg": 149,
	"./PlayHoverIcon.svg": 482,
	"./PlayToggleIcon.svg": 483,
	"./arrowLeft.svg": 484,
	"./back.svg": 277,
	"./before02.svg": 485,
	"./change.svg": 486,
	"./check_box.svg": 487,
	"./checkbox_toggle_white.svg": 488,
	"./checkbox_white.svg": 489,
	"./checked_box.svg": 490,
	"./cineonhubIconWhite.svg": 491,
	"./cineonhub_change.svg": 278,
	"./cineonhub_hover_change.svg": 492,
	"./cineonstudioIconWhite.svg": 493,
	"./cineonstudio_change.svg": 279,
	"./cineonstudio_hover_change.svg": 494,
	"./circle_play.svg": 495,
	"./circle_stop.svg": 496,
	"./close.svg": 497,
	"./closeFilter.svg": 116,
	"./close_tag.svg": 498,
	"./coming_soon.svg": 499,
	"./connectlogo.svg": 500,
	"./csv.svg": 501,
	"./cut.svg": 280,
	"./cutRed.svg": 281,
	"./delete.svg": 282,
	"./docx.svg": 502,
	"./download.svg": 503,
	"./download_hover_toggle.svg": 504,
	"./edit.svg": 283,
	"./fast_forward.svg": 505,
	"./fastrewind01.svg": 284,
	"./fastrewind02.svg": 285,
	"./file.svg": 506,
	"./folder.svg": 507,
	"./full screen_hover_toggle.svg": 319,
	"./full_screen.svg": 265,
	"./index.svg": 320,
	"./index_empty.svg": 321,
	"./info.svg": 200,
	"./info_hover.svg": 322,
	"./jpg.svg": 508,
	"./left.svg": 201,
	"./left2.svg": 162,
	"./left2_hover.svg": 216,
	"./leftAllow.svg": 509,
	"./left_hover.svg": 266,
	"./link.svg": 510,
	"./more_vert_black_24dp.svg": 511,
	"./newIcon.svg": 150,
	"./next02.svg": 512,
	"./noPresenterImage.svg": 97,
	"./partition.svg": 513,
	"./pause.svg": 286,
	"./pdf.svg": 514,
	"./play.svg": 515,
	"./play02.svg": 287,
	"./playIcon.svg": 516,
	"./play_connect.svg": 517,
	"./ppt.svg": 518,
	"./presenterNewIcon.svg": 519,
	"./redo.svg": 288,
	"./rerunSTT.svg": 289,
	"./rewind.svg": 520,
	"./right.svg": 202,
	"./right2.svg": 163,
	"./right2_hover.svg": 217,
	"./rightAllow.svg": 521,
	"./right_hover.svg": 267,
	"./scale01.svg": 522,
	"./scale02.svg": 523,
	"./search.svg": 524,
	"./select.svg": 290,
	"./selectRed.svg": 291,
	"./setting.svg": 292,
	"./share.svg": 525,
	"./share_hover_toggle.svg": 526,
	"./speed.svg": 527,
	"./stop.svg": 528,
	"./tag.svg": 529,
	"./thumnail.svg": 323,
	"./thumsup.svg": 324,
	"./txt.svg": 530,
	"./video_file.svg": 531,
	"./volume.svg": 532,
	"./warningIcon.svg": 533,
	"./xls.svg": 534,
	"./zip.svg": 535
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 481;